import "../../styles/speakersHP.scss";
import { useState, useEffect } from "react";

export default function SpeakerCard({ name, summary, img, resetSignal }) {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setExpanded(false);
  }, [resetSignal]);

  return (
    <article className={`carousel__item ${expanded ? "expanded" : ""}`}>
      <div className="profile-image">
        <img src={img} alt={name} />
      </div>
      <h4 className="speaker-name">{name}</h4>
      <p className="speaker-description">
        {summary.split("\n").map((line, idx) => (
          <>
            {line}
            <br />
          </>
        ))}
      </p>
      <button
        className="speaker-btn"
        onClick={() => setExpanded((prev) => !prev)}
      >
        {expanded ? "See Less" : "See More"}
      </button>
    </article>
  );
}
